
export default function Features() {
  return (
    <section id="features" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 text-teal-600 text-sm font-medium uppercase tracking-wider rounded-lg">
              <i className="ri-star-line text-lg"></i>
              Our Expertise
            </span>
          </div>
          <h3 className="text-5xl font-bold text-gray-900 leading-tight">
            Comprehensive iOS<br />Development Solutions
          </h3>
        </div>

        {/* Features Grid */}
        <div className="space-y-8">
          {/* Row 1 - Three Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Security Focus */}
            <div className="bg-slate-50 rounded-3xl p-10 hover:shadow-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-8">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Security Focus</h4>
              <p className="text-gray-600 leading-relaxed">
                Our VPN development expertise ensures your data remains protected with industry-leading encryption protocols. We implement multi-layered security architectures that safeguard user privacy while maintaining optimal performance and seamless connectivity across all network conditions.
              </p>
            </div>

            {/* Performance Optimization */}
            <div className="bg-slate-50 rounded-3xl p-10 hover:shadow-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-full mb-8">
                <i className="ri-flashlight-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Performance Optimization</h4>
              <p className="text-gray-600 leading-relaxed">
                Specializing in device optimization through our Cleaner application, we employ advanced algorithms to identify and remove unnecessary files, manage memory efficiently, and enhance overall device responsiveness for a smoother user experience.
              </p>
            </div>

            {/* Native iOS Development */}
            <div className="relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] cursor-pointer h-full">
              <img 
                src="https://public.readdy.ai/ai/img_res/bb07872e3b51d0e7849a3bb614f0eb80.jpg"
                alt="Native iOS Development"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-10">
                <h4 className="text-2xl font-bold text-white mb-3">Native iOS Development</h4>
                <p className="text-white/90 leading-relaxed">
                  Building truly native applications using Swift and the latest iOS frameworks for optimal performance and user experience.
                </p>
              </div>
            </div>
          </div>

          {/* Row 2 - Two Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* User Experience Design */}
            <div className="lg:col-span-2 bg-gradient-to-r from-slate-900 to-teal-900 rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] cursor-pointer relative overflow-hidden">
              <div className="absolute top-10 right-10 w-24 h-24 flex items-center justify-center bg-white/10 rounded-full">
                <i className="ri-palette-line text-4xl text-white"></i>
              </div>
              <div className="relative z-10">
                <h4 className="text-3xl font-bold text-white mb-6">User Experience Design</h4>
                <p className="text-white/90 text-lg leading-relaxed max-w-3xl">
                  We prioritize intuitive design and seamless interactions in every application we create. Our UX-focused approach ensures that users can navigate effortlessly through features while enjoying visually appealing interfaces that align with iOS design guidelines. From initial wireframes to final implementation, we craft experiences that delight users and drive engagement.
                </p>
              </div>
            </div>

            {/* Stacked Cards */}
            <div className="space-y-8">
              {/* Swift Development */}
              <div className="bg-orange-50 rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-full">
                    <i className="ri-code-s-slash-line text-xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">Swift Development</h4>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Leveraging Swift's powerful features to build fast, safe, and modern iOS applications with clean, maintainable code.
                </p>
              </div>

              {/* App Store Optimization */}
              <div className="bg-teal-50 rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-full">
                    <i className="ri-app-store-line text-xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">App Store Optimization</h4>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Ensuring your applications meet all App Store guidelines and are optimized for maximum visibility and downloads.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}